(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trip-trolley-premium-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trip-trolley-slider')) {
  customElements.define('trip-trolley-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.ttp-slide')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('[data-prev]').onclick = () => this.show(-1);
      this.querySelector('[data-next]').onclick = () => this.show(1);
      this.toggle.onclick = () => { this.paused = !this.paused; this.update(); };
      this.onmouseenter = () => this.hovered = true;
      this.onmouseleave = () => this.hovered = false;
      this.update();
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !this.contains(document.activeElement) && !document.hidden) this.show(1);
      }, 3000);
    }
    update() {
      this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
      this.querySelector('.ttp-slide-controls').hidden = this.slides.length < 2;
    }
    show(step) {
      if (this.slides.length < 2) return;
      this.slides[this.index].hidden = true;
      this.index = (this.index + step + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trip-trolley-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tt-vanity-slider')) {
 customElements.define('tt-vanity-slider', class extends HTMLElement {
  connectedCallback() {
   this.slides = Array.from(this.querySelectorAll('.tt-vanity-slide'));
   this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
   this.paused = false;
   this.pauseButton = this.querySelector('[data-action="pause"]');
   this.onclick = event => {
    const button = event.target.closest('button[data-action]');
    if (!button) return;
    if (button.dataset.action === 'pause') {
     this.paused = !this.paused;
     button.textContent = this.paused ? '▶' : 'Ⅱ';
     button.setAttribute('aria-label', this.paused ? 'Play vanity slideshow' : 'Pause vanity slideshow');
     this.start();
    } else {
     this.show(this.index + (button.dataset.action === 'next' ? 1 : -1));
     this.start();
    }
   };
   this.show(this.index);
   this.start();
  }
  show(index) {
   if (!this.slides.length) return;
   this.index = (index + this.slides.length) % this.slides.length;
   this.slides.forEach((slide, number) => {
    const active = number === this.index;
    slide.classList.toggle('is-active', active);
    slide.setAttribute('aria-hidden', String(!active));
    slide.tabIndex = active ? 0 : -1;
   });
   this.querySelector('.tt-vanity-count').textContent = String(this.index + 1).padStart(2, '0') + ' / ' + String(this.slides.length).padStart(2, '0');
  }
  start() {
   clearInterval(this.timer);
   if (!this.paused && this.slides.length > 1) this.timer = setInterval(() => {
    if (!document.hidden && !this.contains(document.activeElement)) this.show(this.index + 1);
   }, Number(this.dataset.interval));
  }
  disconnectedCallback() { clearInterval(this.timer); }
 });
}

  } catch(e) { console.error(e); }
})();
})();
